'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
export default function UITooltipContent(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement("div", {
    className: classNames('private-tooltip__inner', className),
    role: "tooltip"
  }, children);
}
UITooltipContent.propTypes = {
  children: PropTypes.node
};
UITooltipContent.displayName = 'UITooltipContent';